<template>
    <div>
        <div class="clearfix" id="footer" >
            <div class="inner">
                <div class="left fl clearfix">
                    <img class="fl icon" src="@/assets/imgs/logo3.png" alt="">
                    <a class="fl name" href="javascript:;">邻友圈</a>
                </div>
                <div class="center fl">
                    <p>社区生活 尽在邻友圈</p>
                    <p class="product">好玩好看和超多有趣邻友一起分享身边事</p>
                </div>
                <div class="right fr">
                    <div class="down fl">
                        <a href="http://app.linyouquan.net" target="_blank">
                            <img class="downImg one" src="@/assets/imgs/phone.png" alt=""><br/>
                        </a>
                        <a href="http://app.linyouquan.net" target="_blank">
                            <img class="downImg" src="@/assets/imgs/and.png" alt="">
                        </a>
                    </div>
                    <div class="code fr">
                        <img src="@/assets/imgs/code.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data() {

            }
        }
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
    #footer{
        padding:25px 60px 15px;
        height: 165px;
        background: url('../../assets/imgs/bg.png') no-repeat;
        .left{
            margin:30px 80px 0 0;
            .icon{
                width:60px;
            }
            .name{
                font-size:@ft28;
                color:white;
                font-weight: 400;
                margin:10px 0 0 10px;
            }
        }
        .center{
            color:white;
            font-size:@ft42;
            .product{
                text-align: center;
                font-weight: 100;
                font-size:@ft22;
                margin-top:12px;
            }
        }
        .right{
            .down{
                margin:0 30px 0 0;
                .downImg{
                    width:160px;
                }
                .one{
                    margin-bottom:5px;
                }
            }
            .code{
                img{
                    width: 120px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue